import { getLanguageCode } from "../../../../utils/common";

export const useCandidateDetails = () => {
  let languageCode: string = getLanguageCode();
  let candidateData: any = sessionStorage.getItem("candidateDetails");
  candidateData = JSON.parse(candidateData);

  //clear candidate data if language is changed
  //this is connected with providing key value to CandidateDetails component to force fresh rerender
  if(candidateData && candidateData.languageCode !== languageCode) {
    sessionStorage.removeItem("candidateDetails")
    return null;
  }

  return candidateData;
};
